<mat-drawer-container class="countable-drawer">

    <mat-drawer-content class="overflow-hidden">
        <!-- <div class="income-state-wrapper">  -->
        <div class="page-wraper bg-gray-50">
            <div class="page-title-block workbook-title-block align-items-start">
                <div class="left-content title-block-left button-group flex-row header-actions">

                    <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip" title="Collapse All"
                            *ngIf="isincomeStatementExpanded" (click)="expandAndCollapse('collapse')">
                        <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
                    </button>
                    <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip" title="Expand All"
                            (click)="expandAndCollapse('expand')" *ngIf="!isincomeStatementExpanded">
                        <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
                    </button>
                    <button mat-button mat-stroked-button title="Refresh" color="dark" class="btn-medium-icon button-tooltip"
                            (click)="refreshIncomeStatement()"
                            [disabled]="(firm?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || shortCutMenuDetails.isenglock !== 0">
                        <i class="fa-regular fa-arrows-rotate"></i>
                    </button>

                </div>
                <div class="title-block-middle flexbox-column gap-0 flex-1 align-items-center">
                    <!-- 1st Column -->
                    <h3 class="title text-center">{{clientName}}</h3>
                    <h3 class="title text-center">{{headerNotesColumn1}}</h3>



                    <!--2nd Column-->
                    <div class="flexbox-row gap-8 justify-content-center text-center">
                        <ng-container *ngIf="isSecondColumnClicked">
                            <mat-form-field class="fixed-label form-field-medium icon-form-after action-2" style="width: 300px">
                                <input matInput placeholder="" #focusInputField [(ngModel)]="headerNotesColumn2"
                                       [ngModelOptions]="{standalone: true}" type="text" class="edit-field" />

                                <div matSuffix class="actions border-start">
                                    <button mat-button color="success" title="Save" (click)="saveHeaderNote()"
                                            [disabled]="!(headerNotesColumn2.trim())"
                                            [ngClass]="[!(headerNotesColumn2.trim()) ? 'btn-disabled' : '']">
                                        <i class="fa-regular fa-check"></i>
                                    </button>
                                    <button mat-button color="error" title="Cancel"
                                            (click)="isSecondColumnClicked = false; headerNotesColumn2 = isOldSecondColumn">
                                        <i class="fa-regular fa-xmark clear-icon"></i>
                                    </button>
                                </div>
                            </mat-form-field>
                            <h6 class="title">{{currentYearIS | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</h6>

                        </ng-container>

                        <ng-container *ngIf="!isSecondColumnClicked">
              <span style="position: relative;display: inline-block;" class="hover-action">
                <h6 class="title hover-action d-flex flex-row align-items-center gap-8"
                    [ngClass]="{'ps-3': shortCutMenuDetails.isenglock === 0}" style="min-height:36px;">
                  <span [ngClass]="{'ps-2': shortCutMenuDetails.isenglock === 0}">{{headerNotesColumn2}} {{currentYearIS
                          | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</span>
                  <ng-container
                          *ngIf="acl?.hasEngViewEdit && shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY">
                    <button mat-button class="button-text hover-action-item"
                            (click)="focusInput();isSecondColumnClicked = true; isThirdColumnClicked = false; isOldSecondColumn = headerNotesColumn2">
                      <i class="fa-regular fa-pen fs-15"></i>
                    </button>
                  </ng-container>
                </h6>
              </span>
                        </ng-container>
                    </div>

                </div>
                <div class="title-block-right d-none d-lg-flex"></div>
            </div>

      <mat-accordion>
        <mat-expansion-panel class="plan-expansion body-expansion" expanded="true">
          <mat-expansion-panel-header class="d-block d-lg-none filter-actions-button">
            <mat-panel-title>
              <div class="plan-expansion-header">
                <button mat-button mat-stroked-button color="dark" class="button-default">
                  <span class="flexbox-row gap-8 flex-nowrap">
                    <span class="title">Actions</span>
                    <span class="toggle-icon dot-16 bg-transparent"></span>
                  </span>
                </button>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="plan-expansion-body">
            <div class="sorting-block d-flex flex-row align-items-end justify-content-between p-24 flex-wrap gap-20">
              <div class="sorting-block-left d-flex flex-row align-items-end gap-8 flex-1">
                <mat-form-field class="form-item fixed-label" floatLabel="always" style="max-width:300px;width:auto;" title="{{clientName}}">
                  <mat-label>Entity Name</mat-label>
                  <mat-select [(value)]="clientName" [disabled]=true title="{{clientName}}">
                    <mat-option value="{{clientName}}">
                      {{clientName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                                <div class="form-item ng-form-field">
                                    <label>Year End Date</label>
                                    <ng-select placeholder="" [items]="yearEndDetails" [clearable]="false" [clearOnBackspace]="false"
                                               bindValue="acctyear" bindLabel="acctdate" [ngModelOptions]="{standalone: true}"
                                               [(ngModel)]="selectedYearEnd" [title]="currentYearIS | appCountableTimeZone: 'MMM d, y':'UTC' "
                                               name="year end" (change)="refreshIncomeStatement()" class="yr-dropdown">
                                        <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                            {{ item.acctdate | appCountableTimeZone: 'MMM d, y':'UTC'}}
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>

                            <form class="sorting-block-right d-flex flex-row gap-8">
                                <mat-form-field class="fixed-label label-none icon-field-before" floatLabel="always">
                                    <mat-label>Search</mat-label>
                                    <input matInput placeholder="Search" maxlength="20" size="20" #searchField [(ngModel)]="searchText"
                                           [ngModelOptions]="{standalone: true}" (keyup)="handleSearch($event.target.value)"
                                           autocomplete="off">
                                    <span matPrefix>
                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  </span>
                                </mat-form-field>
                            </form>

                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="content-block-main overflow-hidden template-block-main">
                <div class="income-state-container-body-grid card h-100 overflow-auto w-100 auto-scroll-container"
                     [ngClass]="{'fixed-footer-enabled':isMoveforIS, 'notes-row': restrictedColumn}" id="grid" cdkScrollable>
                    <div class="flex-table fixed-header hover-action" style="min-width:100%;width:fit-content;">
                        <div class="flex-table-header fixed-top" [ngClass]="{'showcolumns':isDisplayCol}" appSpin
                             [spinnerConfig]="spinnerConfig()">
                            <div class="table-left-section">
                                <p class="ft-header-cell col-status"></p>
                                <p class="ft-header-cell col-group">
                                    <span class="ps-2">Group Name</span>
                                </p>
                            </div>
                            <p class="ft-header-cell col-leadsheet border-start">LS</p>
                            <p class="ft-header-cell col-map">Map No.</p>
                            <p class="ft-header-cell col-nfs border-start" *ngIf="restrictedColumn">
                                <span>Notes to FS</span>
                            </p>
                            <p class="ft-header-cell col-current flex-column gap-0 align-items-end border-start"
                               title="{{currentYearIS | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                <span>{{currentYearIS | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                                <span>{{currentYearIS | appCountableTimeZone:'yyyy':'UTC'}}</span>
                            </p>
                            <ng-container *ngIf="isPrevyear">
                                <ng-container *ngIf="isDisplayCol">
                                    <p class="ft-header-cell col-leadsheet border-start">LS</p>
                                    <p class="ft-header-cell col-map border-end">Map No.</p>
                                    <p class="ft-header-cell col-previous flexbox-row gap-8 flex-nowrap" *ngIf="isPrevyear">
                                        <button mat-button class="button-text" (click)="isPreviousYear()">
                                            <i class="fa-regular fa-circle-minus"></i>
                                        </button>
                                        <span class="flexbox-column gap-0 align-items-end"
                                              title="{{previousYearIS | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                      <span>{{previousYearIS | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                      <span>{{previousYearIS | appCountableTimeZone:'yyyy':'UTC'}}</span>
                    </span>
                                    </p>
                                </ng-container>

                                <ng-container *ngIf="!isDisplayCol">
                                    <p class="ft-header-cell col-previous flexbox-row gap-8 flex-nowrap border-start" *ngIf="isPrevyear">
                                        <button mat-button class="button-text" *ngIf="!isHideActionsForPY" (click)="isPreviousYear()">
                                            <i class="fa-solid fa-plus fs-14"></i>
                                        </button>
                                        <span class="flexbox-column gap-0 align-items-end"
                                              title="{{previousYearIS | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                      <span>{{previousYearIS | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                      <span>{{previousYearIS | appCountableTimeZone:'yyyy':'UTC'}}</span>
                    </span>
                                    </p>
                                </ng-container>
                            </ng-container>
                        </div>

                        <div class="income-state-content" [ngClass]="{'showcolumns':isDisplayCol}">
                            <mat-accordion #accordion="matAccordion" multi="true">
                                <ng-container
                                        *ngFor="let incomeStatementData of incomeStatementdetails; let i = index; trackBy: incomeStatement;">
                                    <!-- <mat-expansion-panel [expanded]="isSearchExist ? incomeStatementData.isexpand : isincomeStatementExpanded" [ngClass]="{'retainedEarnings' : incomeStatementData.id != 4 && incomeStatementData.id != 5  && incomeStatementData.id != 6}" (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)"  #chapterExpansionPanel  (keydown.Space)="$event.stopImmediatePropagation();"> -->
                                    <mat-expansion-panel
                                            [expanded]="isSearchExist ? incomeStatementData.isexpand : isincomeStatementExpanded"
                                            [ngClass]="{'border-btm-dark': dataPresentation == false && incomeStatementData.id == '4.5.3', 'border-top-dark':  incomeStatementData.id == '4.5.1' || incomeStatementData.id == '4.5.3','retainedEarnings' : incomeStatementData.children === undefined && incomeStatementData.trialbal === undefined,
              'net-loss-header-panel' : !incomeStatementData.isexpand && incomeStatementData.id === 11,
              'grandTotal':incomeStatementData.isretainedearining === 1 ||  incomeStatementData.id == 7  ||  incomeStatementData.children === undefined, 'otherExpenses': incomeStatementData.trialbal != undefined, 'separator': incomeStatementData.id == 5 || (incomeStatementData.id == 6  && incomeStatementdetails.length-2 != i && addExpensesSaperator === false) ||  incomeStatementData.id == '142' || (incomeStatementData.id == '6.26.142' && incomeStatementdetails.length-2 != i) ||  (incomeStatementData.id === 10 && incomeStatementdetails.length-2 != i) ||  incomeStatementData.id ===12 }"
                                            (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)" #chapterExpansionPanel
                                            (keydown.Space)="$event.stopImmediatePropagation();">

                                        <!--- first parent lead asheet group-->
                                        <mat-expansion-panel-header class="first-header"
                                                                    (keydown.Space)="$event.stopImmediatePropagation();"
                                                                    (click)="showTotalScore(incomeStatementData)">
                                            <mat-panel-title (keydown.Space)="$event.stopImmediatePropagation();">
                                                <ng-container *ngIf="incomeStatementData.isretainedearining === undefined">
                                                    <div class="flex-table-header">
                                                        <div class="table-left-section">
                                                            <p class="ft-cell col-toogle">
                                <span class="togglable-icon">
                                  <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                </span>
                                                            </p>
                                                            <p class="ft-cell col-header-title py-0" (click)="$event.stopPropagation()">
                                                                <ng-container *ngIf="!incomeStatementData.isEditable">
                                  <span class="text-ellipse fw-semibold">
                                    {{incomeStatementData.name}}
                                  </span>
                                                                    <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                        <ng-container *ngIf="shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY">
                                                                            <button mat-button class="button-text ms-2 hover-action-item" title="Edit"
                                                                                    (click)="editingTitleCheck(incomeStatementData); incomeStatementData.oldvalue = incomeStatementData.name;">
                                                                                <i class="fa-regular fa-pen fs-15"></i>
                                                                            </button>
                                                                        </ng-container>

                                                                        <!-- Compress and expand for revenue at group level -->
                                                                        @if(shortCutMenuDetails.isenglock === 0 && incomeStatementData.id === 4 && !isHideActionsForPY){
                                                                            <button mat-button class="button-text ms-2 hover-action-item"
                                                                                    title="{{incomeStatementData.iscompressenable?'Expand':'Compress'}}"
                                                                                    (click)="saveWbCompressStatus(incomeStatementData, incomeStatementData.iscompressenable)">
                                                                                @if(!incomeStatementData.iscompressenable && !isHideActionsForPY){
                                                                                    <i class="fa-regular fa-arrows-to-line fs-15"></i>
                                                                                }@else if (incomeStatementData.iscompressenable && !isHideActionsForPY) {
                                                                                    <i class="fa-regular fa-arrows-from-line fs-15"></i>
                                                                                }
                                                                            </button>
                                                                        }
                                                                    </ng-container>
                                                                </ng-container>

                                                                <ng-container *ngIf="incomeStatementData.isEditable">
                                                                    <mat-form-field
                                                                            class="mat-form-item fixed-label icon-form-after input-fields-item action-2 form-field-smaller"
                                                                            floatLabel="always">
                                                                        <input matInput type="text" [(ngModel)]="incomeStatementData.name"
                                                                               [ngModelOptions]="{standalone: true}" #focusInputField required>
                                                                        <div matSuffix class="actions border-start">
                                                                            <button mat-button color="success" title="Save"
                                                                                    (click)="incomeStatementData.isEditable=!incomeStatementData.isEditable;UpdateIncomeStatementTitle(incomeStatementData, 'child')"
                                                                                    [disabled]="!(incomeStatementData.name.trim())"
                                                                                    [ngClass]="[!(incomeStatementData.name.trim()) ? 'btn-disabled' : '']">
                                                                                <i class="fa-regular fa-check"></i>
                                                                            </button>
                                                                            <button mat-button color="error" title="Cancel"
                                                                                    (click)="closeTitleEdit(incomeStatementData);incomeStatementData.name=incomeStatementData.oldvalue">
                                                                                <i class="fa-regular fa-xmark clear-icon"></i>
                                                                            </button>
                                                                        </div>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                            </p>
                                                        </div>
                                                        <p class="ft-cell col-leadsheet border-start"></p>
                                                        <p class="ft-cell col-map"></p>
                                                        <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                                                        <p class="ft-cell col-current text-end fw-semibold border-start">
                              <span class="text-ellipse totalValue" title="{{incomeStatementData.Currgrouptotal}}">
                                {{incomeStatementData.Currgrouptotal}}
                              </span>
                                                        </p>
                                                        <ng-container *ngIf="isPrevyear">
                                                            <ng-container *ngIf="isDisplayCol">
                                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                                <p class="ft-cell col-map border-end"></p>
                                                                <p class="ft-cell col-previous text-end">
                                  <span class="fw-semibold totalValue" title="{{incomeStatementData.Prevgrouptotal}}">
                                    {{incomeStatementData.Prevgrouptotal}}
                                  </span>
                                                                </p>
                                                            </ng-container>

                                                            <ng-container *ngIf="!isDisplayCol">
                                                                <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                  <span class="fw-semibold totalValue" title="{{incomeStatementData.Prevgrouptotal}}">
                                    {{incomeStatementData.Prevgrouptotal}}
                                  </span>
                                                                </p>
                                                            </ng-container>
                                                        </ng-container>
                                                        <!--</ng-container>-->
                                                    </div>
                                                </ng-container>

                                                <!--- grand total row start-->
                                                <ng-container *ngIf="incomeStatementData.isretainedearining == 1">
                                                    <div class="flex-table-header">
                                                        <div class="table-left-section">
                                                            <p class="ft-cell col-toogle"></p>
                                                            <p class="ft-cell col-header-title me-auto py-0 flex-1 px-2"
                                                               (click)="$event.stopPropagation()">
                                                                <ng-container *ngIf="!incomeStatementData.isEditable">
                                  <span class="text-ellipse fw-semibold">
                                    {{incomeStatementData.name}}
                                  </span>
                                                                    <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                        <ng-container *ngIf="shortCutMenuDetails.isenglock != 1 && !isHideActionsForPY">
                                                                            <button mat-button class="button-text ms-2 hover-action-item" title="Edit"
                                                                                    (click)="editingTitleCheck(incomeStatementData); incomeStatementData.oldvalue = incomeStatementData.name;">
                                                                                <i class="fa-regular fa-pen fs-15"></i>
                                                                            </button>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </ng-container>

                                                                <ng-container *ngIf="incomeStatementData.isEditable">
                                                                    <mat-form-field
                                                                            class="mat-form-item fixed-label icon-form-after input-fields-item action-2 form-field-smaller"
                                                                            floatLabel="always">
                                                                        <input matInput type="text" [(ngModel)]="incomeStatementData.name"
                                                                               [ngModelOptions]="{standalone: true}" #focusInputField required>
                                                                        <div matSuffix class="actions border-start">
                                                                            <button mat-button color="success" title="Save"
                                                                                    (click)="incomeStatementData.isEditable=!incomeStatementData.isEditable;UpdateIncomeStatementTitle(incomeStatementData, 'child')"
                                                                                    [disabled]="!(incomeStatementData.name.trim())"
                                                                                    [ngClass]="[!(incomeStatementData.name.trim()) ? 'btn-disabled' : '']">
                                                                                <i class="fa-regular fa-check"></i>
                                                                            </button>
                                                                            <button mat-button color="error" title="Cancel"
                                                                                    (click)="closeTitleEdit(incomeStatementData);incomeStatementData.name=incomeStatementData.oldvalue">
                                                                                <i class="fa-regular fa-xmark clear-icon"></i>
                                                                            </button>
                                                                        </div>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                            </p>
                                                        </div>
                                                        <p class="ft-cell col-leadsheet border-start"></p>
                                                        <p class="ft-cell col-map"></p>
                                                        <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                                                        <p class="ft-cell col-current text-end fw-semibold border-start">
                              <span class="text-ellipse" title="{{incomeStatementData.Currgrouptotal}}">
                                {{incomeStatementData.Currgrouptotal}}
                              </span>
                                                        </p>
                                                        <ng-container *ngIf="isPrevyear">
                                                            <ng-container *ngIf="isDisplayCol">
                                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                                <p class="ft-cell col-map border-end"></p>
                                                                <p class="ft-cell col-previous text-end">
                                  <span class="fw-semibold" title="{{incomeStatementData.Prevgrouptotal}}">
                                    {{incomeStatementData.Prevgrouptotal}}
                                  </span>
                                                                </p>
                                                            </ng-container>

                                                            <ng-container *ngIf="!isDisplayCol">
                                                                <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                  <span class="fw-semibold" title="{{incomeStatementData.Prevgrouptotal}}">
                                    {{incomeStatementData.Prevgrouptotal}}
                                  </span>
                                                                </p>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                                <!--- grand total row end-->
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>

                                        <ng-container
                                                *ngFor="let lSgroupchild of incomeStatementData.children; trackBy: incomeStatementChild;">
                                            <mat-expansion-panel
                                                    [expanded]="isSearchExist ? lSgroupchild.isexpand :isincomeStatementExpanded">
                                                <mat-expansion-panel-header class="second-header" (click)="showTotalScore(lSgroupchild)"
                                                                            (keydown.Space)="$event.stopImmediatePropagation();">
                                                    <mat-panel-title (keydown.Space)="$event.stopImmediatePropagation();">
                                                        <div class="flex-table-header">
                                                            <div class="table-left-section">
                                                                <p class="ft-cell col-toogle">
                                  <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                  </span>
                                                                </p>
                                                                <p class="ft-cell col-header-title py-0 px-2" (click)="$event.stopPropagation()">
                                                                    <ng-container *ngIf="!lSgroupchild.isEditable">
                                    <span class="text-ellipse fw-semibold" title="{{lSgroupchild.name}}">
                                      {{lSgroupchild.name}}
                                    </span>
                                                                        <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                            <ng-container *ngIf="shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY">
                                                                                <button mat-button class="button-text ms-2 hover-action-item"
                                                                                        (click)="editingTitleCheck(lSgroupchild); lSgroupchild.oldvalue = lSgroupchild.name;"
                                                                                        title="Edit">
                                                                                    <i class="fa-regular fa-pen fs-15"></i>
                                                                                </button>
                                                                            </ng-container>
                                                                        </ng-container>
                                                                    </ng-container>

                                                                    <ng-container *ngIf="lSgroupchild.isEditable">
                                                                        <mat-form-field
                                                                                class="mat-form-item fixed-label icon-form-after input-fields-item action-2 form-field-smaller"
                                                                                floatLabel="always">
                                                                            <input matInput type="text" [(ngModel)]="lSgroupchild.name"
                                                                                   [ngModelOptions]="{standalone: true}" #focusInputField required>
                                                                            <div matSuffix class="actions border-start">
                                                                                <button mat-button color="success" title="Save"
                                                                                        (click)="lSgroupchild.isEditable=!lSgroupchild.isEditable;UpdateIncomeStatementTitle(lSgroupchild, 'child')"
                                                                                        [disabled]="!(lSgroupchild.name.trim())"
                                                                                        [ngClass]="[!(lSgroupchild.name.trim()) ? 'btn-disabled' : '']">
                                                                                    <i class="fa-regular fa-check"></i>
                                                                                </button>
                                                                                <button mat-button color="error" title="Cancel"
                                                                                        (click)="closeTitleEdit(lSgroupchild);lSgroupchild.name=lSgroupchild.oldvalue">
                                                                                    <i class="fa-regular fa-xmark clear-icon"></i>
                                                                                </button>
                                                                            </div>
                                                                        </mat-form-field>
                                                                    </ng-container>

                                                                    <ng-container
                                                                            *ngIf="acl?.hasEngViewEdit && shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY">
                                                                        <!-- <span class="sort-position" [matMenuTriggerFor]="sortmenu" #sortingMenu="matMenuTrigger"></span> -->
                                                                        <button mat-button class="button-text ms-2 hover-action-item sort-button"
                                                                                (click)="getSubGroupSortingData(lSgroupchild, $event, false)" title="Sorting">
                                                                            <i class="fa-solid fa-arrow-up-long fs-15"></i>
                                                                            <!-- <img alt="sort" [matMenuTriggerFor]="sortmenu" #sortingMenu="matMenuTrigger" src="../../../../assets/images/sort_arrow.svg" /> -->
                                                                        </button>
                                                                    </ng-container>

                                                                    <!-- Compress and expand at sub group level -->
                                                                    @if (shortCutMenuDetails.isenglock === 0 && acl?.hasEngViewEdit && incomeStatementData.id != 4 && incomeStatementData.id != 6 && !isHideActionsForPY) {
                                                                        <button mat-button class="button-text ms-2 hover-action-item"
                                                                                (click)="saveWbCompressStatus(lSgroupchild, incomeStatementData.iscompressenable)"
                                                                                title="{{incomeStatementData.iscompressenable?'Expand':'Compress'}}">
                                                                            @if(!incomeStatementData.iscompressenable && !isHideActionsForPY){
                                                                                <i class="fa-regular fa-arrows-to-line fs-15"></i>
                                                                            }@else if(incomeStatementData.iscompressenable && !isHideActionsForPY){
                                                                                <i class="fa-regular fa-arrows-from-line fs-15"></i>
                                                                            }
                                                                        </button>
                                                                    }

                                                                </p>
                                                            </div>
                                                            <p class="ft-cell col-leadsheet border-start"></p>
                                                            <p class="ft-cell col-map"></p>
                                                            <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                                                            <p class="ft-cell col-current text-end fw-semibold border-start">
                                <span class="text-ellipse totalValue" title="{{lSgroupchild.Currbal}}">
                                  {{lSgroupchild.Currbal}}
                                </span>
                                                            </p>
                                                            <ng-container *ngIf="isPrevyear">
                                                                <ng-container *ngIf="isDisplayCol">
                                                                    <p class="ft-cell col-leadsheet border-start"></p>
                                                                    <p class="ft-cell col-map border-end"></p>
                                                                    <p class="ft-cell col-previous text-end">
                                    <span class="fw-semibold totalValue" title="{{lSgroupchild.Prevbal}}">
                                      {{lSgroupchild.Prevbal}}
                                    </span>
                                                                    </p>
                                                                </ng-container>

                                                                <ng-container *ngIf="!isDisplayCol">
                                                                    <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                    <span class="fw-semibold totalValue" title="{{lSgroupchild.Prevbal}}">
                                      {{lSgroupchild.Prevbal}}
                                    </span>
                                                                    </p>
                                                                </ng-container>
                                                            </ng-container>
                                                        </div>
                                                    </mat-panel-title>
                                                </mat-expansion-panel-header>

                                                <!-- second leadsheet group child -->
                                                <div cdkDropListGroup>
                                                    <ng-container
                                                            *ngFor="let child2 of lSgroupchild.children; trackBy: incomeStatementSubChild; let z=index"
                                                            class="expanded-color">
                                                        @if (child2?.is_schedule_exits && child2?.groupName) {
                                                            <mat-expansion-panel>
                                                                <mat-expansion-panel-header class="third-header"
                                                                                            (keydown.Space)="$event.stopImmediatePropagation();">
                                                                    <mat-panel-title
                                                                            (keydown.Space)="$event.stopImmediatePropagation();">

                                                                        <div class="flex-table-header">
                                                                            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                                                <div class="ft-cell col-toogle">
                                  <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                  </span>
                                                                                </div>
                                                                                <p class="ft-cell col-header-title py-0 flexbox-row gap-8"
                                                                                   (click)="$event.stopPropagation()">
                                                                                 <span class="text-ellipse fw-semibold flexbox-row gap-8"
                                                                                       title="{{child2?.groupName}}">
                                      {{ child2?.groupName }}
                                    </span>
                                                                                    @if (child2?.is_schedule_exits) {
                                                                                        <button mat-button
                                                                                                mat-stroked-button
                                                                                                color="success"
                                                                                                class="btn-small schedule-success-btn"
                                                                                                (click)="selectedSchedule.set(child2)"
                                                                                                [matMenuTriggerFor]="scheduleOperation">
                                                                                            {{ child2?.schedule_name }}
                                                                                            <i class="fa-regular fa-angle-down"></i>
                                                                                        </button>
                                                                                    }

                                                                                </p>
                                                                            </div>



                                                                        </div>
                                                                    </mat-panel-title>
                                                                </mat-expansion-panel-header>
                                                                <ng-container
                                                                        *ngFor="let subChild of child2.children; trackBy: incomeStatementSubChild; let subIndex=index ">
                                                                    <div *ngTemplateOutlet="subGroupChildren; context: { child2: subChild, z : subIndex, lSgroupchild: lSgroupchild, isSubGroup:true, incomeStatementData: incomeStatementData }"></div>
                                                                </ng-container>

                                                            </mat-expansion-panel>
                                                        } @else {
                                                            <div *ngTemplateOutlet="subGroupChildren; context: { child2: child2, z : z, lSgroupchild: lSgroupchild ,isSubGroup:false, incomeStatementData: incomeStatementData}"></div>
                                                        }
                                                    </ng-container>
                                                </div>
                                            </mat-expansion-panel>
                                        </ng-container>

                                        <!---here we are bindign for other coloms with 1level only--->
                                        <ng-container class="expanded-color" *ngIf="incomeStatementData.trialbal != undefined">
                                            <div class="others"
                                                 [ngClass]="{'begining-year': incomeStatementData.trialbal != undefined && (incomeStatementdetails.length-2 != i && incomeStatementData.id != 10 && incomeStatementData.id != '6.26.142')}"
                                                 [expanded]="isSearchExist ? incomeStatementData.isexpand : isincomeStatementExpanded"
                                                 (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)" #chapterExpansionPanel
                                                 (keydown.Space)="$event.stopImmediatePropagation();">

                                                <!-- second leadsheet group child -->
                                                <div cdkDropList id="{{incomeStatementData.id}}" [cdkDropListConnectedTo]="connectedTo"
                                                     (cdkDropListDropped)="drop($event, incomeStatementData)"
                                                     [cdkDropListData]="incomeStatementData.trialbal" class="balance-sheet-list-container">
                                                    <div class="ft-row"
                                                         *ngFor="let child3 of incomeStatementData.trialbal; trackBy: incomeStatementTrialbal;"
                                                         cdkDrag [cdkDragDisabled]="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit"
                                                         [cdkDragData]="child3" (cdkDragMoved)="onDragMoved($event)"
                                                         (mouseover)="child3.selected = true" (mouseout)="child3.selected = false"
                                                         [ngStyle]="{'cursor': shortCutMenuDetails.isenglock !== 0 || !acl?.hasEngViewEdit ? '' : 'grab'}">
                                                        <div class="table-left-section">
                                                            <p class="ft-cell col-status">
                                <span class="status-badge" [ngClass]="{'bg-error':child3.LSchange == 1}">
                                  <span class="status-badge-label">
                                    <ng-container *ngIf="child3.LSchange == 1">CHG</ng-container>
                                  </span>
                                </span>
                                                            </p>
                                                            <p class="ft-cell col-drag-drop" [hidden]="shortCutMenuDetails.isenglock != 0">
                                                                <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                    <ng-container *ngIf="shortCutMenuDetails.isenglock === 0">
                                                                        <button mat-button class="button-text hover-action-item cursor-grab"
                                                                                *ngIf="child3.selected && this.selectedTrailBLrow.length < 2">
                                                                            <i class="fa-solid fa-grip-dots-vertical"></i>
                                                                        </button>
                                                                    </ng-container>
                                                                </ng-container>
                                                            </p>
                                                            <p class="ft-cell col-checkbox">
                                                                <ng-container
                                                                        *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementCheckbox3">
                                                                    <mat-checkbox class="label-none" disabled></mat-checkbox>
                                                                </ng-container>
                                                                <ng-template #showWorkBookIncomeStatementCheckbox3>
                                                                    <mat-checkbox class="label-none" [(ngModel)]="child3.checked"
                                                                                  [ngModelOptions]="{standalone: true}"
                                                                                  (ngModelChange)="checkChange(child3,incomeStatementData,  'otherIncomes', incomeStatementData)"
                                                                                  [checked]="child3.checked"
                                                                                  (click)="changePosition($event, child3);enableDeletSeletedItem(incomeStatementData)">
                                    <span class="checkboxDropdown position-absolute"
                                          [matMenuTriggerFor]="checkboxDropdown" #multipleMoveMenu="matMenuTrigger"></span>
                                                                    </mat-checkbox>
                                                                    <mat-menu #checkboxDropdown="matMenu" class="bs-check-dropdown max-w-initial"
                                                                              [hasBackdrop]="false">
                                                                        <div class="flexbox-row h-100 overflow-hidden gap-0"
                                                                             (click)="$event.stopPropagation()">
                                                                            <div class="leadsheet-map-container-section-left h-100 overflow-hidden"
                                                                                 style="width: 150px;">
                                                                                <button mat-menu-item class="w-100" [disabled]="leadsheetdisable"
                                                                                        (click)="activeMultiLs(child3, $event)">
                                                                                    <div class="flexbox-row gap-8 justify-content-between">
                                                                                        <span class="button-label">Leadsheet</span>
                                                                                        <i class="fa-regular fa-angle-right ms-auto me-auto"></i>
                                                                                    </div>
                                                                                </button>
                                                                                <button mat-menu-item class="w-100" (click)="activeMultiMapNo(child3, $event)">
                                                                                    <div class="flexbox-row gap-8 justify-content-between">
                                                                                        <span class="button-label">Map No.</span>
                                                                                        <i class="fa-regular fa-angle-right ms-auto me-auto"></i>
                                                                                    </div>
                                                                                </button>
                                                                                <div class="button-group p-2 border-top">
                                                                                    <button mat-button mat-stroked-button color="dark" class="button-default"
                                                                                            (click)="openGroupPopup()"
                                                                                            [disabled]="disableAddGroupButton || leadsheetdisable || isHideActionsForPY">
                                                                                        <span class="button-label">Create Group</span>
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            <ng-container *ngIf="activeLsMove || activeMapMove">
                                                                                <div
                                                                                        class="leadsheet-container-right ls-menu flexbox-column gap-0 h-100 overflow-hidden border-start flex-1">
                                                                                    <div class="button-group justify-content-end px-2 pt-2">
                                                                                        <button mat-button class="button-text" (click)="clearSelection()">
                                                                                            <i class="fa-regular fa-xmark"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                    <div
                                                                                            class="leadsheet-map-container-section-right map-section-right overflow-auto h-100">
                                                                                        <!--Latest LS to move-->
                                                                                        <ng-container *ngIf="child3.isLeadSheet && activeLsMove">
                                                                                            <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                                                                                         [moveType]="'MULTI'" [subscribeFrom]="'IS'"></ls-dropdown>
                                                                                        </ng-container>
                                                                                        <!--Latest Map No. move-->
                                                                                        <ng-container *ngIf="child3.isMap && activeMapMove">
                                                                                            <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                                                                                          [moveType]="'MULTI'" [yearEnd]="selectedYearEnd" [subscribeFrom]="'IS'">
                                                                                            </map-dropdown>
                                                                                        </ng-container>
                                                                                    </div>

                                                                                    <div class="button-group justify-content-end p-2">
                                                                                        <button mat-button mat-flat-button color="primary" class="button-default"
                                                                                                [disabled]="isDisableMoveButton"
                                                                                                (click)="activeLsMove ? saveLeadSheetdetails():savemappingdetails()">Move</button>
                                                                                    </div>
                                                                                </div>
                                                                            </ng-container>
                                                                        </div>
                                                                    </mat-menu>
                                                                </ng-template>
                                                            </p>
                                                            <p class="ft-cell col-group pe-2">
                                                                <span class="text-ellipse" title="{{child3.accountname}}">{{child3.accountname}}</span>
                                                            </p>
                                                        </div>
                                                        <p class="ft-cell col-leadsheet border-start">
                                                            <ng-container
                                                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementLeadSheetButtons1">
                                                                <button title="{{child3.leadsheet}}" mat-button class="button-text w-100" disabled>
                                                                    <span class="text-ellipse">{{child3.leadsheet}}</span>
                                                                </button>
                                                            </ng-container>
                                                            <ng-template #showWorkBookIncomeStatementLeadSheetButtons1>
                                                                <button title="{{child3.leadsheet}}" mat-button class="button-text w-100"
                                                                        [matMenuTriggerFor]="gidLeadeShaeetItems" (click)="activeLSDropdown(child3,'current')"
                                                                        [disabled]="!isindividualRowSaveforIS">
                                                                    <span class="text-ellipse">{{child3.leadsheet}}</span>
                                                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                                                </button>
                                                                <mat-menu #gidLeadeShaeetItems="matMenu" class="ls-menu" xPosition="before">
                                                                    <ng-container *ngIf="child3.isLeadSheet && isindividualRowSaveforIS">
                                                                        <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                                                                     [moveType]="'SINGLE'" [yearType]="'CURRENT'" [subscribeFrom]="'IS'">
                                                                        </ls-dropdown>
                                                                    </ng-container>
                                                                </mat-menu>
                                                            </ng-template>
                                                        </p>
                                                        <p class="ft-cell col-map">
                                                            <ng-container
                                                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementMapButtons">
                                                                <button title="{{child3.mapno}}" mat-button class="button-text w-100" disabled>
                                                                    <span class="text-ellipse">{{child3.mapno}}</span>
                                                                </button>
                                                            </ng-container>

                                                            <ng-template #showWorkBookIncomeStatementMapButtons>
                                                                <button title="{{child3.mapno}}" mat-button [matMenuTriggerFor]="gridMapNumDropDown"
                                                                        class="button-text w-100" (click)="mappingNumber(child3, 'current')"
                                                                        [disabled]="!isindividualRowSaveforIS">
                                                                    <span class="text-ellipse">{{child3.mapno}}</span>
                                                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                                                </button>
                                                                <mat-menu #gridMapNumDropDown="matMenu" class="map-menu map-dropdown-container"
                                                                          xPosition="before">
                                                                    <ng-container *ngIf="child3.isMap && isindividualRowSaveforIS">
                                                                        <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                                                                      [moveType]="'SINGLE'" [yearType]="'CURRENT'" [yearEnd]="selectedYearEnd"
                                                                                      [subscribeFrom]="'IS'"></map-dropdown>
                                                                    </ng-container>
                                                                </mat-menu>
                                                            </ng-template>
                                                        </p>
                                                        <p class="ft-header-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                                                        <p class="ft-cell col-current text-end border-start" title="{{child3.Currbal}}">
                                                            <span>{{child3.Currbal}}</span>
                                                        </p>
                                                        <ng-container *ngIf="isPrevyear">
                                                            <ng-container *ngIf="isDisplayCol">
                                                                <p class="ft-cell col-leadsheet border-start">
                                                                    <ng-container
                                                                            *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementLeadSheetButtons2">
                                                                        <button title="{{child3.prevleadsheet}}" mat-button
                                                                                class="button-text locked-item w-100" disabled>
                                                                            <span class="text-ellipse">{{child3.prevleadsheet}}</span>
                                                                        </button>
                                                                    </ng-container>
                                                                    <ng-template #showWorkBookIncomeStatementLeadSheetButtons2>
                                                                        <button title="{{child3.prevleadsheet}}" mat-button class="button-text w-100"
                                                                                [matMenuTriggerFor]="gidLeadeShaeetItems"
                                                                                (click)="activeLSDropdown(child3, 'previous')"
                                                                                [disabled]="!isindividualRowSaveforIS">
                                                                            <span class="text-ellipse">{{child3.prevleadsheet}}</span>
                                                                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                                                        </button>
                                                                        <mat-menu #gidLeadeShaeetItems="matMenu" class="ls-menu" xPosition="before">
                                                                            <ng-container *ngIf="child3.isLeadSheet && isindividualRowSaveforIS">
                                                                                <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                                                                             [moveType]="'SINGLE'" [yearType]="'CURRENT'" [subscribeFrom]="'IS'">
                                                                                </ls-dropdown>
                                                                            </ng-container>
                                                                        </mat-menu>
                                                                    </ng-template>
                                                                </p>
                                                                <p class="ft-cell col-map border-end">
                                                                    <ng-container
                                                                            *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementMapButtons3">
                                                                        <button title="{{child3.mapname ? child3.mapname : '-'}}" mat-button
                                                                                class="button-text locked-item w-100" disabled>
                                                                            <span class="text-ellipse">{{child3.prevmapno}}</span>
                                                                        </button>
                                                                    </ng-container>
                                                                    <ng-template #showWorkBookIncomeStatementMapButtons3>
                                                                        <button title="{{child3.mapname ? child3.mapname : '-'}}" mat-button
                                                                                [matMenuTriggerFor]="gridMapNumDropDown" class="button-text w-100"
                                                                                (click)="mappingNumber(child3, 'previous')"
                                                                                [disabled]="!isindividualRowSaveforIS">
                                                                            <span class="text-ellipse">{{child3.prevmapno}}</span>
                                                                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                                                        </button>
                                                                        <mat-menu #gridMapNumDropDown="matMenu" class="map-menu map-dropdown-container"
                                                                                  xPosition="before">
                                                                            <ng-container *ngIf="child3.isMap && isindividualRowSaveforIS">
                                                                                <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                                                                              [moveType]="'SINGLE'" [yearType]="'CURRENT'" [yearEnd]="selectedYearEnd"
                                                                                              [subscribeFrom]="'IS'"></map-dropdown>
                                                                            </ng-container>
                                                                        </mat-menu>
                                                                    </ng-template>
                                                                </p>
                                                                <p class="ft-cell col-previous text-end">
                                  <span class="fw-semibold" title="{{child3.Prevbal}}">
                                    {{child3.Prevbal}}
                                  </span>
                                                                </p>
                                                            </ng-container>

                                                            <ng-container *ngIf="!isDisplayCol">
                                                                <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                  <span class="text-ellipse fw-semibold" title="{{child3.Prevbal}}">
                                    {{child3.Prevbal}}
                                  </span>
                                                                </p>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>

                                                    <div class="ft-row child-panel-footer">
                                                        <div class="table-left-section">
                                                            <p class="ft-cell col-status"></p>
                                                            <p class="ft-cell col-drag-drop"></p>
                                                            <p class="ft-cell col-checkbox"></p>
                                                            <p class="ft-cell col-group flex-1">
                                <span class="fw-semibold text-ellipse" title="{{incomeStatementData.totalname}}">
                                  {{incomeStatementData.totalname}}
                                </span>
                                                            </p>
                                                        </div>
                                                        <p class="ft-cell col-leadsheet border-start"></p>
                                                        <p class="ft-cell col-map"></p>
                                                        <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                                                        <p class="ft-cell col-current text-end border-start">
                              <span class="text-ellipse fw-semibold" title="{{incomeStatementData.Currbal}}">
                                {{incomeStatementData.Currgrouptotal}}
                              </span>
                                                        </p>
                                                        <ng-container *ngIf="isPrevyear">
                                                            <ng-container *ngIf="isDisplayCol">
                                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                                <p class="ft-cell col-map border-end"></p>
                                                                <p class="ft-cell col-previous text-end">
                                  <span class="fw-semibold" title="{{incomeStatementData.Prevbal}}">
                                    {{incomeStatementData.Prevgrouptotal}}
                                  </span>
                                                                </p>
                                                            </ng-container>

                                                            <ng-container *ngIf="!isDisplayCol">
                                                                <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                  <span class="text-ellipse fw-semibold" title="{{incomeStatementData.Prevbal}}">
                                    {{incomeStatementData.Prevgrouptotal}}
                                  </span>
                                                                </p>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <!-- parent footer-->
                                        <div class="ft-row new parent-footer"
                                             *ngIf="incomeStatementData.children != undefined  && incomeStatementData.id != 8">
                                            <div class="table-left-section">
                                                <p class="ft-cell col-status"></p>
                                                <p class="ft-cell col-drag-drop"></p>
                                                <p class="ft-cell col-checkbox"></p>
                                                <p class="ft-cell col-group">
                          <span class="fw-semibold text-ellipse"
                                title="{{incomeStatementData.totalname}}">{{incomeStatementData.totalname}}</span>
                                                </p>
                                            </div>
                                            <p class="ft-cell col-leadsheet border-start"></p>
                                            <p class="ft-cell col-map"></p>
                                            <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                                            <p class="ft-cell col-current text-end border-start">
                        <span class="text-ellipse fw-semibold" title="{{incomeStatementData.Currgrouptotal}}">
                          {{incomeStatementData.Currgrouptotal}}
                        </span>
                                            </p>
                                            <ng-container *ngIf="isPrevyear">
                                                <ng-container *ngIf="isDisplayCol">
                                                    <p class="ft-cell col-leadsheet border-start"></p>
                                                    <p class="ft-cell col-map border-end"></p>
                                                    <p class="ft-cell col-previous text-end">
                            <span class="fw-semibold" title="{{incomeStatementData.Prevgrouptotal}}">
                              {{incomeStatementData.Prevgrouptotal}}
                            </span>
                                                    </p>
                                                </ng-container>

                                                <ng-container *ngIf="!isDisplayCol">
                                                    <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                            <span class="text-ellipse fw-semibold" title="{{incomeStatementData.Prevgrouptotal}}">
                              {{incomeStatementData.Prevgrouptotal}}
                            </span>
                                                    </p>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </mat-expansion-panel>
                                </ng-container>
                            </mat-accordion>

                            <ng-container *ngIf="roundingData$ | async as roundingDifference">
                                <div class="ft-row opening-balance">
                                    <div class="table-left-section">
                                        <p class="ft-cell col-status"></p>
                                        <p class="ft-cell col-drag-drop"></p>
                                        <p class="ft-cell col-checkbox"></p>
                                        <p class="ft-cell col-group"></p>
                                    </div>
                                    <p class="ft-cell col-leadsheet"></p>
                                    <p class="ft-cell col-map"></p>
                                    <p class="ft-cell col-nfs" *ngIf="restrictedColumn"></p>
                                    <p class="ft-cell col-current text-end border-start">
                                        <ng-container *ngIf="roundingDifference && roundingDifference.hasCYRoundingDifference">
                      <span class="text-ellipse text-error fw-semibold" title="{{roundingDifference.cyDisplayValue}}">
                        {{roundingDifference.cyDisplayValue}}
                      </span>
                                        </ng-container>
                                    </p>
                                    <ng-container *ngIf="isPrevyear">
                                        <ng-container *ngIf="isDisplayCol">
                                            <p class="ft-cell col-leadsheet border-start"></p>
                                            <p class="ft-cell col-map border-end"></p>
                                            <p class="ft-cell col-previous text-end">
                                                <ng-container *ngIf="roundingDifference && roundingDifference.hasPyRoundingDifference">
                          <span class="text-error fw-semibold" title="{{roundingDifference.pyDisplayValue}}">
                            {{roundingDifference.pyDisplayValue}}
                          </span>
                                                </ng-container>
                                            </p>
                                        </ng-container>

                                        <ng-container *ngIf="!isDisplayCol">
                                            <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                                <ng-container *ngIf="roundingDifference && roundingDifference.hasPyRoundingDifference">
                          <span class="text-error fw-semibold" title="{{roundingDifference.pyDisplayValue}}">
                            {{roundingDifference.pyDisplayValue}}
                          </span>
                                                </ng-container>
                                            </p>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <!-- previously condition was "isMoveforIS" Keeping false as per latest designs-->
                <ng-container *ngIf="showPreviousYeardata">
                    <div class="fixed-panel-bottom fixed-bottom">
                        <div class="select">
                            <div class="flex-box-vc-hl">
                                <mat-radio-group aria-label="Select an option" class="radiogroup">
                                    <mat-radio-button value="Leadsheet" [checked]="isLeadSheet" (change)="radioChange($event)">Lead Sheet
                                    </mat-radio-button>
                                    <mat-radio-button value="MapNo" [checked]="!isLeadSheet" (change)="radioChange($event)">Map No.
                                    </mat-radio-button>
                                </mat-radio-group>

                                <div class="basic">
                                    <h4>Move To</h4>
                                    <button *ngIf="!isLeadSheet" mat-stroked-button [matMenuTriggerFor]="gridMapNumDropDown"
                                            (click)="isMapSheetMenu=true">Map No.</button>
                                    <button *ngIf="isLeadSheet" mat-stroked-button [matMenuTriggerFor]="gidLeadeShaeetItems"
                                            (click)="isLeadsheetNO=true" [disabled]="leadsheetdisable">Lead Sheet</button>

                                    <mat-menu #gridMapNumDropDown="matMenu" class="map-dropdown-container" #beforeMenu="matMenu"
                                              xPosition="before">

                                        <div class="map-num-dropdown" *ngIf="isMapSheetMenu">
                                            <div class="map-num-dropdown-header">
                                                <input (click)="$event.stopPropagation()" matInput
                                                       (keyup)="applyFilterToMapSheet($event.target.value)" placeholder="Search">
                                            </div>
                                            <div class="map-num-dropdown-body">
                                                <table mat-table [dataSource]="mapNumData" class="mapping-tbl-grid">
                                                    <ng-container matColumnDef="mapno">
                                                        <th mat-header-cell *matHeaderCellDef> ID </th>
                                                        <td mat-cell title="{{mapelement.mapno}}" *matCellDef="let mapelement">
                                                            {{mapelement.mapno}}
                                                        </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="mapsheetname">
                                                        <th mat-header-cell *matHeaderCellDef> Description </th>
                                                        <td mat-cell title="{{mapelement.mapsheetname}}" *matCellDef="let mapelement">
                                                            {{mapelement.mapsheetname}}
                                                        </td>
                                                    </ng-container>

                                                    <tr mat-header-row *matHeaderRowDef="mappingColumns; sticky: true"></tr>
                                                    <tr mat-row *matRowDef="let row1; columns: mappingColumns;"
                                                        (click)="mapSheetData(row1);isMapSheetMenu=false"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </mat-menu>

                                    <mat-menu #gidLeadeShaeetItems="matMenu" class="map-dropdown-container leadsheet-container"
                                              #beforeMenu="matMenu" xPosition="before">
                                        <div class="map-num-dropdown" *ngIf="isLeadsheetNO">
                                            <div class="map-num-dropdown-header">
                                                <div><input (click)="$event.stopPropagation()"
                                                            (keyup)="applyFilterToLeadSheet($event.target.value)" matInput placeholder="Search"></div>
                                            </div>
                                            <div class="map-num-dropdown-body">
                                                <div class="flex-box-left-right map-num-dropdown-body-header">
                                                    <h6 (click)="$event.stopPropagation()">Leadsheet</h6>
                                                    <button class="transparent-btn no-pad"
                                                            (click)="$event.stopPropagation();createLeadsheetItem()">
                                                        <i class="fa-solid fa-plus fs-14"></i>
                                                    </button>
                                                </div>

                                                <table mat-table [dataSource]="leadSheetData" class="mapping-tbl-grid">
                                                    <!--Description-->
                                                    <ng-container matColumnDef="leadSheetCode">
                                                        <th mat-header-cell *matHeaderCellDef (click)="$event.stopPropagation()"
                                                            class="leadsheet-name">Lead Sheet Name</th>
                                                        {{leadSheetData}}
                                                        <td mat-cell title="{{LSDetails.leadsheetcode}}-{{LSDetails.leadsheetname}}"
                                                            *matCellDef="let LSDetails">
                                                            {{LSDetails.leadsheetcode}}-{{LSDetails.leadsheetname}}
                                                        </td>
                                                    </ng-container>

                                                    <tr mat-header-row *matHeaderRowDef="leadSheetColumns; sticky: true"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: leadSheetColumns;"
                                                        (click)="leadSheetDetail(row);isLeadsheetNO=false;"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </mat-menu>

                                </div>
                                <div class="button">
                                    <button *ngIf="isLeadSheet" mat-button class="move" (click)="saveLeadSheetdetails()">Move</button>
                                    <button *ngIf="!isLeadSheet" mat-button class="move" (click)="savemappingdetails()">Move</button>
                                </div>
                            </div>
                            <div class="button">
                                <button mat-icon-button (click)="clearSelection();isMoveforIS=false">
                                    <i class="fa-regular fa-xmark"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="bs-footer hover-action flexbox-row justify-content-center" style="min-height:40px;"
                 *ngIf="notes && notes.length != 0">
                <ng-container *ngIf="!isFooterNoteEdited && !isHideActionsForPY">
                    <p class="bs-footer-text hover-action">
                        {{footerNote}}
                    </p>
                    <button mat-button class="button-text hover-action-item ms-2" (click)="editFooterNotes();">
                        <i class="fa-regular fa-pen fs-15"></i>
                    </button>
                </ng-container>
                <ng-container *ngIf="isFooterNoteEdited">
                    <mat-form-field class="fixed-label icon-form-after action-2 form-field-medium w-300" floatLabel="always">
                        <input matInput type="text" [(ngModel)]="footerNote" [ngModelOptions]="{standalone: true}" #focusInputField>
                        <div matSuffix class="actions border-start">
                            <button mat-button color="success" title="Save" (click)="saveFooterNote()"
                                    [disabled]="!(footerNote.trim())" [ngClass]="[!(footerNote.trim()) ? 'btn-disabled' : '']">
                                <i class="fa-regular fa-check"></i>
                            </button>
                            <button mat-button color="error" title="Cancel" (click)="cancelEditFooterNote();">
                                <i class="fa-regular fa-xmark clear-icon"></i>
                            </button>
                        </div>
                    </mat-form-field>
                </ng-container>
            </div>
        </div>
    </mat-drawer-content>

    <mat-drawer #drawer class="order-2 drawer-from-right prev-right-drawer">
        <div class="toogle-button-block button-block-right">
            <button mat-button class="button-medium-icon toogle-button" (click)="drawer.toggle()"></button>
            <div class="toogle-content">
                <h6 class="title">Preview</h6>
            </div>
        </div>
        <div class="income-state-container-aside w-100 overflow-auto">
            <!-- <div class="income-state-container-aside-body"> -->
            <income-sheet-preview></income-sheet-preview>
            <!-- <div class="preview-footer" *ngIf="isHideFooterNotesToFS">
            <div class="bs-footer preview-footer-head">
              <p class="bs-footer-text ellipse no-marg">
                {{footerNote}}
              </p>
            </div>
          </div> -->
        </div>
    </mat-drawer>
</mat-drawer-container>
<!-- </div> -->

<!-- Dailog Box-->

<ng-template #createLeadsheetDialog>
    <div class="create-leadsheet-dialog">
        <div class="full-row flex-box-left-right">
            <h1 mat-dialog-title class="no-marg">Create New Lead Sheet</h1>
            <button mat-icon-button [mat-dialog-close]>
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>

        <div mat-dialog-content>
            <form autoComplete="off">
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <mat-label>Group</mat-label>
                        <mat-select [disableOptionCentering]="true">
                            <mat-option>Assets</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <mat-label>Sub Group</mat-label>
                        <mat-select [disableOptionCentering]="true">
                            <mat-option>C - Assets</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <mat-label>Lead Sheet Code</mat-label>
                        <mat-select [disableOptionCentering]="true">
                            <mat-option>1001</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <input matInput placeholder="Lead Sheet Name">
                    </mat-form-field>
                </div>
            </form>
        </div>
        <div mat-dialog-actions>
            <div class="full-row flex-box-right">
                <button mat-flat-button color="primary" [mat-dialog-close]>Add</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- save lead sheet message box -->
<ng-template #saveIncomeLeadsheetDialog>
    <div class="countable-dialog confirmation-dailog saveIncomeLeadsheetDialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
            <h4 class="title">Move Leadsheet</h4>
            <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>You are trying to move to Lead Sheet <span class="fw-semibold">{{leadSheetName}}</span>.</p>
            <p>Do you want to continue?</p>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]
        (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
        (click)="saveLeadSheetdetails()">Yes</button>
    </div>
  </div>
</ng-template>

<!--save Map No. message box -->
<ng-template #saveIncomeMapNoDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
            <h4 class="title">Move Map No.</h4>
            <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>You are trying to move to Map Number <span class="fw-semibold">{{mapNo}}</span>.</p>
            <p>Do you want to continue?</p>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]
        (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
        (click)="savemappingdetails()">Yes</button>
    </div>
  </div>
</ng-template>

<!-- Group dialogbox -->
<ng-template #GroupDialogBox>
    <div class="create-group countable-dialog">

        <div mat-dialog-title class="dialog-header">
            <h4 class="title">Create Group</h4>
            <button mat-button class="close" [mat-dialog-close] (click)="clearSelection()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content">

            <mat-form-field floatLabel="always" class="fixed-label w-100">
                <mat-label>Group Name </mat-label>
                <input matInput type="text" placeholder="Group name" [(ngModel)]="groupName"
                       [ngModelOptions]="{standalone: true}" />
            </mat-form-field>

            <p class="selected-items">Following selected items from existing group will be moved to the new group</p>

            <div class="create-group-grid-head card flex-table">
                <div class="flex-table-header">
          <span class="ft-header-cell" style="width: 40px;max-width:40px;">
            <mat-checkbox class="create-check head-check custom-checkbox" (change)="toggleLineItems($event)"
                          [checked]="isCheckedAll"></mat-checkbox>
          </span>
                    <span class="ft-header-cell" style="width: 250px;">Sub Group Name</span>
                    <span class="ft-header-cell">LS</span>
                </div>
                <div class="ft-row" *ngFor="let ls of selectedLSTrailBLrow">
                    <p class="ft-cell" style="width: 40px;max-width:40px;">
                        <mat-checkbox class="label-none" [(ngModel)]="ls.checked" [ngModelOptions]="{standalone: true}"
                                      (change)="removeChildItem(ls)" [checked]="ls.checked">
                        </mat-checkbox>
                    </p>
                    <span class="ft-cell" style="width: 250px;" title="{{ls.accountname}}">
            <span class="text-ellipse">{{ls.accountname}}</span>
          </span>
                    <p class="ft-cell" title="{{ls.leadsheet}}">
                        <span class="text-ellipse">{{ls.leadsheet}}</span>
                    </p>
                </div>
            </div>
        </div>

    <div class="dialog-footer" *ngIf="isManualGroupExists == 1">
      <mat-error *ngIf="isManualGroupExists == 1">Cannot create a group as the items selected are already in a
        custom group. Please ungroup the items and try again.
      </mat-error>
    </div>
    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-flat-button color="primary" class="button-default" title="Create" [mat-dialog-close]
        (click)="createGroup()"
        [disabled]="disabledGroupButton || !groupName || (isManualGroupExists == 1)">Create</button>
    </div>
  </div>
</ng-template>

<!-- Ungroup Dialog Box -->
<ng-template #UngroupDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
            <h4 class="title"></h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>You are trying to ungroup '<span class="fw-semibold">{{unGroupName}}</span>',all the line items will be moved
                to its parent location.</p>
            <p>Do you want to continue?</p>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]>No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true"
        (click)="unGroup()">Yes</button>
    </div>
  </div>
</ng-template>

<!-- Add Group dialog box -->
<ng-template #AddgroupDialog>
    <div class="add-group-container countable-dialog">
        <div mat-dialog-title class="dialog-header">
            <h4 class="title">Add Items</h4>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content px-0">
            <div class="flex-table">
                <div class="flex-table-header">
                    <p class="ft-header-cell add-group-checkbox">
                        <span class="text-ellipse"></span>
                    </p>
                    <p class="ft-header-cell add-group-name">
                        <span class="text-ellipse"></span>
                    </p>
                    <p class="ft-header-cell add-group-ls">
                        <span class="text-ellipse add-group-ls">Ls</span>
                    </p>
                    <p class="ft-header-cell add-group-mapno">
                        <span class="text-ellipse">Map No.</span>
                    </p>
                    <p class="ft-header-cell add-group-notes" *ngIf="restrictedColumn">
                        <span class="text-ellipse">Notes to FS</span>
                    </p>
                    <p class="ft-header-cell add-group-currentyear">
                        <span class="text-ellipse">{{currentYearIS}}</span>
                    </p>
                    <p class="ft-header-cell add-group-previousyear" *ngIf="previousYearIS">
                        <span class="text-ellipse">{{previousYearIS| appCountableTimeZone:'MMMM d yyyy':'UTC'}}</span>
                    </p>
                </div>

        <div class="flex-table-body">
          <div class="ft-row" *ngFor="let item of addNewElementsList">
            <p class="ft-cell add-group-checkbox">
              <mat-checkbox class="label-none" (click)="addNewSelectedItem(item)"></mat-checkbox>
            </p>
            <p class="ft-cell add-group-name" title="{{item.accountname}}">
              <span class="text-ellipse">{{item.accountname}}</span>
            </p>
            <p class="ft-cell add-group-ls" title="{{item.leadsheet}}">
              <span class="text-ellipse">{{item.leadsheet}}</span>
            </p>
            <p class="ft-cell add-group-mapno" title="{{item.mapno}}">
              <span class="text-ellipse">{{item.mapno}}</span>
            </p>
            <p class="ft-cell add-group-notes" title="notes" *ngIf="restrictedColumn">
              <a class="text-ellipse text-link">Notes</a>
            </p>
            <p class="ft-cell add-group-currentyear" title="{{item.Currbal}}">
              <span class="text-ellipse">{{item.Currbal}}</span>
            </p>
            <p class="ft-cell add-group-previousyear" title="{{item.Prevbal}}">
              <span class="text-ellipse">{{item.Prevbal}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-action class="dialog-footer justify-content-end">
      <button mat-button mat-flat-button class="button-default" color="primary" title="Add" [mat-dialog-close]
        (click)="submitSelectedAddItems()">Add</button>
    </div>
  </div>
</ng-template>

<span class="sort-position" [matMenuTriggerFor]="sortmenu" #sortingMenu="matMenuTrigger"></span>

<mat-menu #sortmenu="matMenu" class="sort-menu" [hasBackdrop]="false">
    <div class="flexbox-column gap-0 h-100 overflow-hidden" (click)="$event.stopPropagation()">
        <div class="flexbox-row justify-content-between p-2">
            <h4>Sort</h4>
            <button mat-button class="button-text" (click)="closeSort()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div class="flexbox-row px-2 mb-2 justify-content-between">
            <mat-radio-group class="flexbox-row" aria-label="Select an option" [(ngModel)]="sortGroup"
                             [ngModelOptions]="{standalone: true}">
                <mat-radio-button (change)="disableSortBtn(s.value)" [value]="s.value"
                                  *ngFor="let s of sortArray"><span>{{s.name}}</span></mat-radio-button>
            </mat-radio-group>
            <div class="button-group" *ngIf="sortGroup != 'AUTO'">
                <button mat-button class="button-text" (click)="manualSorting('UP')" [disabled]="isDisableUpArrow">
          <span *ngIf="!isDisableUpArrow">
            <i class="fa-regular fa-arrow-up"></i>
          </span>
                    <ng-container *ngIf="isDisableUpArrow">
                        <i class="fa-regular fa-arrow-up text-gray-3"></i>
                    </ng-container>
                </button>
                <button mat-button class="button-text" (click)="manualSorting('DOWN')" [disabled]="isDisableDownArrow">
          <span *ngIf="!isDisableDownArrow">
            <i class="fa-solid fa-arrow-down"></i>
          </span>
                    <ng-container *ngIf="isDisableDownArrow">
                        <i class="fa-solid fa-arrow-down text-gray-3"></i>
                    </ng-container>
                </button>
            </div>
        </div>

        <div class="w-100 flex-table fixed-header flex-1 overflow-auto">
            <div class="flex-table-header">
                <div class="ft-row">
                    <p class="ft-header-cell cell-check" *ngIf="sortGroup == 'MAN'"></p>
                    <p class="ft-header-cell flex-nowrap cell-group-name gap-8">
                        <span>Sub Group</span>
                        <button mat-button class="button-text" *ngIf="sortGroup == 'AUTO'" (click)="toggleSort('group')">
                            <i class="fa-regular fs-15" [ngClass]="(groupisASC ? 'fa-arrow-down' : 'fa-arrow-up')"></i>
                        </button>
                    </p>
                    <p class="ft-header-cell flex-1 text-end flex-nowrap gap-8 cell-sort-value">
                        <span>Amount</span>
                        <button mat-button class="button-text" *ngIf="sortGroup == 'AUTO'" (click)="toggleSort('amount')">
                            <i class="fa-regular fs-15" [ngClass]="(amountisASC ? 'fa-arrow-down' : 'fa-arrow-up')"></i>
                        </button>
                    </p>
                </div>
            </div>
            <div class="flex-table-body">
                <div class="ft-row" *ngFor="let sort of sortData">
                    <p class="ft-cell cell-check" *ngIf="sortGroup == 'MAN'">
                        <mat-checkbox class="label-none" [(ngModel)]="sort.checked" [ngModelOptions]="{standalone: true}"
                                      (change)="onChangeAddManualData(sort)"
                                      [disabled]="sortCheckboxLength > 0 ? !sort.checked : sort.checked"></mat-checkbox>
                    </p>
                    <p class="ft-cell cell-group-name" title="{{sort.subgroupname}}">
                        <span class="text-ellipse">{{sort.subgroupname}}</span>
                    </p>
                    <p class="ft-cell text-end flex-1 cell-sort-value" title="{{sort.sortvalue}}">
                        <span class="text-ellipse">{{sort.sortvalue}}</span>
                    </p>
                </div>
            </div>
        </div>

    <div class="button-group p-2 border-top w-100">
      <button mat-button mat-flat-button color="primary" class="button-default flex-1" title="Apply"
        [disabled]="disableSort" (click)="onCLickSaveSorting()">Apply</button>
    </div>
  </div>
</mat-menu>

<!--dialog layout-->

<ng-template #notesFSLinkingDialog>
    <div class="countable-dialog template-block-main right-drawer-dialog max-w-100 w-350 mh-100">
        <div mat-dialog-title class="dialog-header p-2" (click)="$event.stopPropagation()">
            <h4 class="title">
                Link Notes to Financial Statement
            </h4>
            <button mat-button class="close" [mat-dialog-close]>
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div class=" dialog-body-content p-0">
            <div class="flexbox-column gap-8 px-2">
                <mat-form-field class="fixed-label w-100" floatLabel="always">
                    <mat-label>Financial Statement Item to Link:</mat-label>
                    <mat-select [(ngModel)]="notesSRc" (ngModelChange)="changednotesLinks()">
                        <div style="padding: 1rem;">
                            <ng-container style="padding: 1rem;" *ngFor="let subgroup of originalIncomeStatementdetails">
                <span *ngIf="subgroup.children && subgroup.children.length">{{subgroup.name}}
                    {{subgroup.Currgrouptotal}}</span>
                                <ng-container *ngIf="subgroup.children && subgroup.children.length">
                                    <div style="padding: 1rem;" *ngFor="let item of subgroup.children">{{item.name}}
                                        {{item.Currbal}}
                                        <mat-option class="fs-items-option" *ngFor="let option of item.children" [value]="option">
                                            {{option.name}} {{option.Currbal}}
                                        </mat-option>
                                    </div>
                                </ng-container>

                            </ng-container>
                        </div>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fixed-label w-100 icon-form-before" floatLabel="always">
                    <mat-label>Select notes to link:</mat-label>
                    <input matInput id="searchKeyword" name="searchKeyword" type="text" [(ngModel)]="searchKeyword"
                           (keyup.backspace)="searchNotes()" (keyup)="searchNotes()" #searchField placeholder="Search" maxlength="100"
                           autocomplete="off">
                    <span matPrefix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
          </span>
                </mat-form-field>

                <mat-checkbox [checked]="isSelectAll" [(ngModel)]="isSelectAll"
                              (change)="selectAll($event);disablegreenbutton=false;" id="isSelectAll" name="selectAll">
                    <span>Select all</span>
                </mat-checkbox>
            </div>


            <div class="templates-list w-100 h-100">
                <ng-container *ngFor="let category of notes; trackBy: trackByRecords;let i=index">
                    <ng-container *ngIf="category.notes">
                        <mat-accordion class="w-100" #accordion="matAccordion" multi="true">
                            <mat-expansion-panel hideToggle [expanded]="category.isExpand">
                                <mat-expansion-panel-header
                                        [ngClass]="{'checked': category.is_checked == true, 'searchActive': category.highlight}">
                                    <mat-panel-title>
                    <span class="title-content">
                      <mat-checkbox (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                                    class="label-none" [checked]="category.is_checked" (click)="$event.stopPropagation()">
                      </mat-checkbox>
                      <span class="togglable-icon">
                        <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                      </span>
                      <span class="item-icon">
                        <img src="assets/images/ui-uplift-icons/global/colored-folder-icon.svg" alt="">
                      </span>
                      <span class="item-title">{{category.engNoteId}}. {{category.name}}</span>
                    </span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <ul class="templates-list-items">
                                    <li [ngClass]="{'active': note.is_checked == true,  'searchActive': note.highlight}"
                                        *ngFor="let note of category.notes;let j=index">
                                        <mat-checkbox (change)="is_recordChecked(i,'subcategory',j);disablegreenbutton=false;"
                                                      class="list-item-content" [checked]="note.is_checked" (click)="$event.stopPropagation()">
                      <span class="flexbox-row">
                        <span class="item-icon">
                          <img src="/assets/images/icons/notes-icon.svg" alt="Toogle">
                        </span>
                        <span class="item-title"><span class="numbering">{{note.engNoteId}}.</span>{{note.name}}</span>
                      </span>
                                        </mat-checkbox>
                                    </li>
                                </ul>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </ng-container>

                    <ng-container *ngIf="!category.notes">
                        <ul class="templates-list-items">
                            <li [ngClass]="{'checked': category.is_checked == true, 'searchActive': category.highlight}">
                                <mat-checkbox class="list-item-content"
                                              (change)="is_recordChecked(i,'category');disablegreenbutton=false;" [checked]="category.is_checked"
                                              (click)="$event.stopPropagation()">
                  <span class="flexbox-row gap-8">
                    <span class="item-icon">
                      <img src="/assets/images/icons/notes-icon.svg" alt="Toogle"></span>
                    <span class="item-title">{{category.engNoteId}}. {{category.name}}</span>
                  </span>
                                </mat-checkbox>
                            </li>
                        </ul>
                    </ng-container>
                </ng-container>
            </div>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-flat-button class="button-default" color="primary" *ngIf="!disablegreenbutton"
        (click)="saveLinkNotes()" [mat-dialog-close] [disabled]="shortCutMenuDetails.isenglock !== 0">
        Link/Unlink Notes {{getCheckedNotes().length>0?"("+getCheckedNotes().length+")":''}}
      </button>
      <button mat-button mat-flat-button color="success" class="button-default"
        *ngIf="getBalancesheet_Notes_Link_Obj().notes && getBalancesheet_Notes_Link_Obj().notes.length && disablegreenbutton"
        [disabled]="disablegreenbutton || shortCutMenuDetails.isenglock !== 0" (click)="saveLinkNotes()">
        Linked notes {{getCheckedNotes().length>0?"("+getCheckedNotes().length+")":''}}
      </button>
    </div>
  </div>
</ng-template>


<!--mat options for schedule view " -->
<mat-menu #scheduleOperation="matMenu">
    <button mat-menu-item  (click)="viewSchedule(selectedSchedule().combined_id)" >
        <span class="flexbox-row gap-8">
            <i class="fa-regular fa-eye"></i>
            <span>View</span>
        </span>

    </button>
    <button mat-menu-item (click)="deleteSchedule()">
        <span class="flexbox-row gap-12">
            <i class="fa-regular fa-trash-can fs-16"></i>
            <span>Delete</span>
        </span>

    </button>
</mat-menu>


<ng-template #subGroupChildren let-child2="child2" let-z="z" let-lSgroupchild="lSgroupchild" let-isSubGroup="isSubGroup" let-incomeStatementData="incomeStatementData" >
    <mat-expansion-panel
            [expanded]="isSearchExist ? child2.isexpand : isincomeStatementExpanded"
            (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)" #chapterExpansionPanel
            (keydown.Space)="$event.stopImmediatePropagation();">
        <mat-expansion-panel-header
                (keydown.Space)="$event.stopImmediatePropagation();" (click)="showTotalScore(child2)"
                [ngClass]="{'childlevel' : z != 0, 'fourth-header': isSubGroup, 'third-header': !isSubGroup}">
            <mat-panel-title (keydown.Space)="$event.stopImmediatePropagation();">
                <div class="flex-table-header">
                    <div class="table-left-section">
                        <p class="ft-cell col-toogle">
                                        <span class="togglable-icon">
                                          <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                        </span>
                        </p>
                        <p class="ft-cell col-checkbox" (click)="$event.stopPropagation()">
                            <ng-container
                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementCheckbox">
                                <mat-checkbox class="label-none" disabled></mat-checkbox>
                            </ng-container>
                            <ng-template #showWorkBookIncomeStatementCheckbox>
                                <mat-checkbox class="label-none" [(ngModel)]="child2.checked"
                                              [ngModelOptions]="{standalone: true}"
                                              (ngModelChange)="subGroupCheckChange(child2, lSgroupchild)"
                                              (click)="changePosition($event, child2)" (change)="onChangeMatCheckbox()"></mat-checkbox>
                            </ng-template>
                        </p>
                        <p class="ft-cell col-header-title py-0 px-2" (click)="$event.stopPropagation()">
                            <ng-container *ngIf="!child2.isEditable">
                                          <span class="text-ellipse fw-semibold" title="{{child2.name}}">
                                            {{child2.name}}
                                          </span>
                                <ng-container
                                        *ngIf="acl?.hasEngViewEdit && shortCutMenuDetails.isenglock === 0 && !isHideActionsForPY">
                                    <button mat-button class="button-text ms-2 hover-action-item" title="Edit"
                                            (click)="editingTitleCheck(child2); child2.oldvalue = child2.name;">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                    </button>
                                    @if (!child2.isuseradded) {
                                        @if (child2?.is_schedule_exits) {
                                            <button mat-button
                                                    mat-stroked-button
                                                    color="success"
                                                    class="btn-small schedule-success-btn"
                                                    (click)="selectedSchedule.set(child2)"
                                                    [matMenuTriggerFor]="scheduleOperation">
                                                {{ child2?.schedule_name }}
                                                <i class="fa-regular fa-angle-down"></i>
                                            </button>
                                        } @else {
                                            <button mat-button
                                                    mat-flat-button
                                                    color="secondary"
                                                    [disabled]="shortCutMenuDetails.isenglock != 0 || isAddSchedule()"
                                                    (click)="addSchedule(child2)"
                                                    class="btn-small button-hover-left">
                                                <i class="fa-regular fa-plus"></i>Schedule
                                                <span class="hover-label mob-hover-label schedule-label">Add Schedule</span>
                                            </button>
                                        }
                                    }
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="child2.isEditable">
                                <mat-form-field
                                        class="mat-form-item fixed-label icon-form-after input-fields-item action-2 form-field-smaller"
                                        floatLabel="always" (click)="$event.stopPropagation()">
                                    <input matInput type="text" [(ngModel)]="child2.name"
                                           [ngModelOptions]="{standalone: true}" #focusInputField required>
                                    <div matSuffix class="actions border-start">
                                        <button mat-button color="success" title="Save"
                                                [ngClass]="{'readOnly':child2.name.length==0, 'btn-disabled' :!(child2.name.trim())}"
                                                (click)="child2.isEditable=!child2.isEditable;UpdateIncomeStatementTitle(child2, 'subChild')"
                                                [disabled]="!(child2.name.trim())">
                                            <i class="fa-regular fa-check"></i>
                                        </button>
                                        <button mat-button color="error" title="Cancel"
                                                (click)="closeTitleEdit(child2);child2.name=child2.oldvalue">
                                            <i class="fa-regular fa-xmark clear-icon"></i>
                                        </button>
                                    </div>
                                </mat-form-field>
                            </ng-container>

                            <ng-container *ngIf="acl?.hasEngViewEdit">
                                <div class="button-group gap-8 ms-2"
                                     *ngIf="child2.isuseradded == 1 && shortCutMenuDetails.isenglock === 0">
                                    <button mat-button class="button-text hover-action-item"
                                            (click)="openunGroupPopup(child2)">
                                        <i class="fa-regular fa-puzzle fs-15"></i>
                                    </button>
                                    <button mat-button class="button-text hover-action-item"
                                            (click)="addgroupDialog(child2, lSgroupchild.id, incomeStatementData)">
                                        <i class="fa-solid fa-plus fs-14"></i>
                                    </button>
                                    <button mat-button class="button-text hover-action-item"
                                            *ngIf="child2.deleteSelectItem" (click)="deleteSelectedItems(child2)">
                                        <i class="fa-regular fa-trash-can"></i>
                                    </button>
                                </div>
                            </ng-container>
                        </p>
                    </div>
                    <p class="ft-cell col-leadsheet border-start"></p>
                    <p class="ft-cell col-map"></p>
                    <p class="ft-cell col-nfs border-start gap-8">
                        <ng-container *ngIf="restrictedColumn && selectedYearEnd==accYearEnd">
                            <button *ngIf="child2.Currbal!= '-' " class="text-link"
                                    (click)="notesFSLinkingSelectionDialogFunc(child2)">
                                <i class="fa-solid fa-plus fs-14"></i>
                            </button>
                            <ng-container
                                    *ngFor="let notes of child2.notes|sortBy:'asc':'engNoteId' let index = index; let l = count">
                                <button mat-button class="button-text" matTooltip={{notes.notename}}
                                        matTooltipClass="ntfs-tooltip"
                                        (click)="navigateFsNotes('/trial-balance-working-sheet/fs-notes', notes.engNoteId)">
                                            <span class="text-ellipse">
                                              {{notes.engNoteId}}
                                            </span>
                                    <span *ngIf="index+1 != l">,</span>
                                </button>
                            </ng-container>
                        </ng-container>
                    </p>
                    <p class="ft-cell col-current text-end fw-semibold border-start">
                                      <span class="text-ellipse totalValue" title=" {{child2.Currbal}}">
                                        {{child2.Currbal}}
                                      </span>
                    </p>
                    <ng-container *ngIf="isPrevyear">
                        <ng-container *ngIf="isDisplayCol">
                            <p class="ft-cell col-leadsheet border-start"></p>
                            <p class="ft-cell col-map border-end"></p>
                            <p class="ft-cell col-previous text-end">
                                          <span class="fw-semibold totalValue" title="{{child2.Prevbal}}">
                                            {{child2.Prevbal}}
                                          </span>
                            </p>
                        </ng-container>

                        <ng-container *ngIf="!isDisplayCol">
                            <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                          <span class="fw-semibold totalValue" title="{{child2.Prevbal}}">
                                            {{child2.Prevbal}}
                                          </span>
                            </p>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- second leadsheet group child -->
        <!-- <ul cdkDropList id="{{child2.id}}"
      [cdkDropListConnectedTo]="connectedTo" (cdkDropListDropped)="drop($event)" [cdkDropListData]="child2.trialbal"> -->
        <div cdkDropList id="{{child2.id}}" [cdkDropListConnectedTo]="connectedTo"
             (cdkDropListDropped)="drop($event, child2)" [cdkDropListData]="child2.trialbal">
            <div class="ft-row"
                 *ngFor="let child3 of child2.trialbal; trackBy: incomeStatementTrialbal;" cdkDrag
                 [cdkDragData]="child3" (cdkDragMoved)="onDragMoved($event)"
                 [cdkDragDisabled]="!child3.isDraggable || shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit || child2.isuseradded == 1 && isHideActionsForPY"
                 (mouseover)="child3.selected = true" (mouseout)="child3.selected = false"
                 cdkDragBoundary=".auto-scroll-container-out"
                 [ngStyle]="{'cursor': shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit ? '' : 'grab'}"
                 [ngClass]="{'searchActive': child3?.ishighlight ===1, 'five-header': isSubGroup }">
                <div class="table-left-section">
                    <p class="ft-cell col-status" [ngClass]="{'col-toogle': isSubGroup}">
                                      <span class="status-badge" [ngClass]="{'bg-error':child3.LSchange == 1}">
                                        <span class="status-badge-label">
                                          <ng-container *ngIf="child3.LSchange == 1">CHG</ng-container>
                                        </span>
                                      </span>
                    </p>
                    <p class="ft-cell col-drag-drop"
                       [ngClass]="{'disabled': child2.isuseradded == 1 && isHideActionsForPY}">
                        <ng-container *ngIf="acl?.hasEngViewEdit">
                            <ng-container *ngIf="shortCutMenuDetails.isenglock === 0">
                                <button mat-button class="button-text hover-action-item cursor-grab"
                                        *ngIf="child3.selected && this.selectedTrailBLrow.length < 2">
                                    <i class="fa-solid fa-grip-dots-vertical"></i>
                                </button>
                            </ng-container>
                        </ng-container>
                    </p>
                    <p class="ft-cell col-checkbox">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementCheckbox2">
                            <mat-checkbox class="label-none" disabled></mat-checkbox>
                        </ng-container>
                        <ng-template #showWorkBookIncomeStatementCheckbox2>
                            <mat-checkbox class="label-none" [(ngModel)]="child3.checked"
                                          [ngModelOptions]="{standalone: true}"
                                          (ngModelChange)="checkChange(child3,child2,  lSgroupchild.id, incomeStatementData)"
                                          [checked]="child3.checked" (change)="onChangeMatCheckbox()"
                                          (click)="changePosition($event, child3);enableDeletSeletedItem(child2)"></mat-checkbox>
                            <span class="checkboxDropdown position-absolute"
                                  [matMenuTriggerFor]="checkboxDropdown"
                                  #multipleMoveMenu="matMenuTrigger"></span>
                            <mat-menu #checkboxDropdown="matMenu" [hasBackdrop]="false"
                                      class="bs-check-dropdown max-w-initial one">
                                <div class="flexbox-row h-100 overflow-hidden gap-0"
                                     (click)="$event.stopPropagation()" (keydown.tab)="$event.stopPropagation()"
                                     (keydown.shift.tab)="$event.stopPropagation()" tabindex="-1"
                                     style="display: none;" id="LSMAPDialog">
                                    <div class="leadsheet-map-container-section-left h-100 overflow-hidden"
                                         style="width: 150px;">
                                        <button mat-menu-item class="w-100" [disabled]="leadsheetdisable"
                                                [ngStyle]="{'background': activeLsMove ? 'rgba(0, 0, 0, 0.04)' : ''}"
                                                (click)="activeMultiLs(child3, $event)">
                                            <div class="flexbox-row gap-8 justify-content-between">
                                                <span class="button-label">Leadsheet</span>
                                                <i class="fa-regular fa-angle-right ms-auto me-auto"></i>
                                            </div>
                                        </button>
                                        <button mat-menu-item class="w-100"
                                                [ngStyle]="{'background': activeMapMove ? 'rgba(0, 0, 0, 0.04)' : ''}"
                                                (click)="activeMultiMapNo(child3, $event)">
                                            <div class="flexbox-row gap-8 justify-content-between">
                                                <span class="button-label">Map No.</span>
                                                <i class="fa-regular fa-angle-right ms-auto me-auto"></i>
                                            </div>
                                        </button>
                                        <div class="button-group w-100 p-2 border-top">
                                            <button mat-button mat-stroked-button class="button-default flex-1"
                                                    (click)="openGroupPopup()"
                                                    [disabled]="(disableAddGroupButton || leadsheetdisable || isHideActionsForPY)"
                                                    color="dark">
                                                <span class="button-label">Create Group</span>
                                            </button>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="activeLsMove || activeMapMove">
                                        <div
                                                class="ls-menu flexbox-column gap-0 h-100 overflow-hidden border-start flex-1">
                                            <div class="button-group justify-content-end px-2 pt-2">
                                                <button mat-button class="button-text" (click)="clearSelection()">
                                                    <i class="fa-regular fa-xmark"></i>
                                                </button>
                                            </div>

                                            <div
                                                    class="leadsheet-map-container-section-right map-section-right overflow-auto h-100">
                                                <!--Latest LS to move-->
                                                <ng-container *ngIf="child3.isLeadSheet && activeLsMove">
                                                    <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                                                 [moveType]="'MULTI'" [subscribeFrom]="'IS'"></ls-dropdown>
                                                </ng-container>
                                                <!--Latest Map No. move-->
                                                <ng-container *ngIf="child3.isMap && activeMapMove">
                                                    <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                                                  [moveType]="'MULTI'" [yearEnd]="selectedYearEnd"
                                                                  [subscribeFrom]="'IS'">
                                                    </map-dropdown>
                                                </ng-container>
                                            </div>

                                            <div class="button-group justify-content-end p-2 border-top"
                                                 *ngIf="hideMoveButton">
                                                <button mat-button mat-flat-button color="primary"
                                                        class="button-default" [disabled]="isDisableMoveButton"
                                                        (click)="activeLsMove ? saveLeadSheetdetails():savemappingdetails()">
                                                    Move
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </mat-menu>
                        </ng-template>
                    </p>
                    <p class="ft-cell col-group">
                                      <span class="text-ellipse"
                                            title="{{child3.accountname}}">{{child3.accountname}}</span>
                    </p>
                </div>
                <p class="ft-cell col-leadsheet border-start">
                    <ng-container
                            *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementLeadSheetButtons">
                        <button mat-button class="button-text w-100" title="{{child3.leadsheet}}"
                                disabled>
                            <span class="text-ellipse">{{child3.leadsheet}}</span>
                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                        </button>
                    </ng-container>
                    <ng-template #showWorkBookIncomeStatementLeadSheetButtons>
                        <button mat-button class="button-text w-100" title="{{child3.leadsheet}}"
                                [matMenuTriggerFor]="gidLeadeShaeetItems"
                                (click)="activeLSDropdown(child3, 'current')"
                                [disabled]="!isindividualRowSaveforIS">
                            <span class="text-ellipse">{{child3.leadsheet}}</span>
                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                        </button>
                        <mat-menu #gidLeadeShaeetItems="matMenu" class="ls-menu" xPosition="before">
                            <ng-container *ngIf="child3.isLeadSheet && isindividualRowSaveforIS">
                                <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                             [moveType]="'SINGLE'" [yearType]="'CURRENT'" [subscribeFrom]="'IS'">
                                </ls-dropdown>
                            </ng-container>
                        </mat-menu>
                    </ng-template>
                </p>
                <p class="ft-cell col-map">
                    <ng-container
                            *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementMapButtons1">
                        <button mat-button class="button-text"
                                title="{{child3.mapname ? child3.mapname : '-'}}" disabled>
                            <span class="text-ellipse">{{child3.mapno}}</span>
                        </button>
                    </ng-container>
                    <ng-template #showWorkBookIncomeStatementMapButtons1>
                        <button mat-button class="button-text w-100"
                                title="{{child3.mapname ? child3.mapname : '-'}}"
                                [matMenuTriggerFor]="gridMapNumDropDown"
                                (click)="mappingNumber(child3,  'current')"
                                [disabled]="!isindividualRowSaveforIS">
                            <span class="text-ellipse">{{child3.mapno}}</span>
                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                        </button>
                        <mat-menu #gridMapNumDropDown="matMenu" class="map-menu" xPosition="before">
                            <ng-container *ngIf="child3.isMap && isindividualRowSaveforIS">
                                <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                              [moveType]="'SINGLE'" [yearType]="'CURRENT'" [yearEnd]="selectedYearEnd"
                                              [subscribeFrom]="'IS'"></map-dropdown>
                            </ng-container>
                        </mat-menu>
                    </ng-template>
                </p>
                <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn">
                    <!-- <button mat-button class="button-text" (click)="notesFSLinkingSelectionDialogFunc(child2)">
                      <i class="fa-regular fa-link-simple"></i>
                    </button>
                    <ng-container *ngFor="let notes of child2.notes|sortBy:'asc':'engNoteId' let index = index; let l = count">
                      <button mat-button class="button-text" matTooltip={{notes.notename}} matTooltipClass="ntfs-tooltip" (click)="navigateToNotesToFs(notes.engNoteId)">
                        <span class="text-ellipse">{{notes.engNoteId}}</span>
                        <span *ngIf="index+1 != l">,</span>
                      </button>
                    </ng-container> -->
                </p>
                <p class="ft-cell col-current text-end border-start" title="{{child3.Currbal}}">
                    <span class="fw-semibold totalValue">{{child3.Currbal}}</span>
                </p>
                <ng-container *ngIf="isPrevyear">
                    <ng-container *ngIf="isDisplayCol">
                        <p class="ft-cell col-leadsheet border-start">
                            <ng-container
                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementLeadSheetButtons1">
                                <button title="{{child3.prevleadsheet}}" mat-button class="button-text w-100"
                                        disabled>
                                    <span class="text-ellipse">{{child3.prevleadsheet}}</span>
                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                </button>
                            </ng-container>
                            <ng-template #showWorkBookIncomeStatementLeadSheetButtons1>
                                <button title="{{child3.prevleadsheet}}" mat-button class="button-text w-100"
                                        [matMenuTriggerFor]="gidLeadeShaeetItems"
                                        (click)="activeLSDropdown(child3, 'previous')"
                                        [disabled]="!isindividualRowSaveforIS">
                                    <span class="text-ellipse">{{child3.prevleadsheet}}</span>
                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                </button>
                                <mat-menu #gidLeadeShaeetItems="matMenu" class="ls-menu" xPosition="before">
                                    <ng-container *ngIf="child3.isLeadSheet && isindividualRowSaveforIS">
                                        <ls-dropdown [TbLeadSheetId]="TbLeadSheetId" [parentObject]="child3"
                                                     [moveType]="'SINGLE'" [yearType]="'PREVIOUS'" [subscribeFrom]="'IS'">
                                        </ls-dropdown>
                                    </ng-container>
                                </mat-menu>
                            </ng-template>
                        </p>
                        <p class="ft-cell col-map border-end">
                            <ng-container
                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookIncomeStatementMapButtons2">
                                <button title="{{child3.mapname ? child3.mapname : '-'}}" mat-button
                                        class="button-text" disabled>
                                    <span class="text-ellipse">{{child3.prevmapno}}</span>
                                </button>
                            </ng-container>
                            <ng-template #showWorkBookIncomeStatementMapButtons2>
                                <button title="{{child3.mapname ? child3.mapname : '-'}}" mat-button
                                        class="button-text w-100" [matMenuTriggerFor]="gridMapNumDropDown"
                                        (click)="mappingNumber(child3,  'previous')"
                                        [disabled]="!isindividualRowSaveforIS">
                                    <span class="text-ellipse">{{child3.prevmapno}}</span>
                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                </button>
                                <mat-menu #gridMapNumDropDown="matMenu"
                                          class="map-menu map-dropdown-container" #beforeMenu="matMenu"
                                          xPosition="before">
                                    <ng-container *ngIf="child3.isMap && isindividualRowSaveforIS">
                                        <map-dropdown [tbMapsheetId]="tbMapSheetId" [parentObject]="child3"
                                                      [moveType]="'SINGLE'" [yearType]="'PREVIOUS'"
                                                      [yearEnd]="selectedYearEnd" [subscribeFrom]="'IS'"></map-dropdown>
                                    </ng-container>
                                </mat-menu>
                            </ng-template>
                        </p>
                        <p class="ft-cell col-previous text-end">
                                        <span class="fw-semibold totalValue" title="{{child3.Prevbal}}">
                                          {{child3.Prevbal}}
                                        </span>
                        </p>
                    </ng-container>

                    <ng-container *ngIf="!isDisplayCol">
                        <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                        <span class="fw-semibold totalValue" title="{{child3.Prevbal}}">
                                          {{child3.Prevbal}}
                                        </span>
                        </p>
                    </ng-container>
                </ng-container>
            </div>

            <div class="ft-row details-footer 1">
                <div class="table-left-section">
                    <p class="ft-cell col-status"></p>
                    <p class="ft-cell col-drag-drop"></p>
                    <p class="ft-cell col-checkbox"></p>
                    <p class="ft-cell col-group">
                                      <span class="fw-semibold text-ellipse"
                                            title="{{child2.totalname}}">{{child2.totalname}}</span>
                    </p>
                </div>
                <p class="ft-cell col-leadsheet border-start"></p>
                <p class="ft-cell col-map"></p>
                <p class="ft-cell col-nfs border-start" *ngIf="restrictedColumn"></p>
                <p class="ft-cell col-current text-end border-start">
                                    <span class="text-ellipse fw-semibold" title="{{child2.Currbal}}">
                                      {{child2.Currbal}}
                                    </span>
                </p>
                <ng-container *ngIf="isPrevyear">
                    <ng-container *ngIf="isDisplayCol">
                        <p class="ft-cell col-leadsheet border-start"></p>
                        <p class="ft-cell col-map border-end"></p>
                        <p class="ft-cell col-previous text-end">
                                        <span class="text-ellipse fw-semibold" title="{{child2.Prevbal}}">
                                          <span>{{child2.Prevbal}}</span>
                                        </span>
                        </p>
                    </ng-container>

                    <ng-container *ngIf="!isDisplayCol">
                        <p class="ft-cell col-previous text-end border-start" *ngIf="isPrevyear">
                                        <span class="text-ellipse fw-semibold" title="{{child2.Prevbal}}">
                                          {{child2.Prevbal}}
                                        </span>
                        </p>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </mat-expansion-panel>
</ng-template>
